<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";

import TabJadwalAsesmen from "./components/tab-jadwal-asesmen.vue";

export default {
  components: {
    Layout,
    PageHeader,
		TabJadwalAsesmen,
  },

  data() {
    return {
      title: 'Histori Asesmen',
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">

				<b-tabs class="honor-tabs" nav-class="nav-tabs-custom">
					<b-tab title="Asesmen KKJ" active>
						<TabJadwalAsesmen tipeAsesmen="kkj" />
					</b-tab>
					<b-tab title="Pembinaan Grade">
						<TabJadwalAsesmen tipeAsesmen="pembinaan_grade" />
					</b-tab>
				</b-tabs>
      </div>
    </div>
  </Layout>
</template>
